import { Check, Clear, Refresh } from '@mui/icons-material';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import { SignatureComponent } from '@syncfusion/ej2-react-inputs';
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { convertBlobToBase64 } from '../../../Shared/Files/ConvertBlobToBase64';
import { BozpDocumentNewsResponseDTO, BozpDocumentNewsType } from '../../../../ApiOld/Api/ApiServerVov';

interface MobileDocumentsSignatureProps {
    onSigned: (signature: string) => void;
    open: boolean;
    onClose: () => void;
    data: BozpDocumentNewsResponseDTO;
}

export default function MobileDocumentsSignature(props: MobileDocumentsSignatureProps) {
    const { onSigned, open, onClose, data } = props;
    const signRef = useRef<SignatureComponent>(null);
    const { t } = useTranslation();
    const [loading, setLoading] = React.useState<boolean>(false);

    const [isSigned, setIsSigned] = React.useState(false);

    const handleCheckSignature = () => {
        if (signRef.current) {
            const isEmpty = signRef.current.isEmpty();
            setIsSigned(!isEmpty);
            console.log(isEmpty ? 'No signature found' : 'Signature is filled');
        }
    };

    useEffect(() => {
        setLoading(false);
    }, [open]);

    const handleSaveAsBase64 = async () => {
        if (signRef.current) {
            setLoading(true);
            const blob = await signRef.current.saveAsBlob();

            // Convert Blob to Base64
            const base64 = await convertBlobToBase64(blob);
            console.log(base64);
            onSigned(base64);
        }
    };


    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullScreen>
            <DialogTitle>
                <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                    <Typography variant="h6">{t('signHere')}</Typography>
                    <IconButton onClick={onClose}>
                        <Clear />
                    </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        padding: '16px',
                        border: '1px solid lightgray',
                        borderRadius: '6px',
                        backgroundColor: '#F9F9F9',
                    }}
                >
                    <SignatureComponent
                        ref={signRef}
                        change={handleCheckSignature}
                        //onChange={(e) => { console.log('dddddxxx', e); setSignatureChanged(true); }}

                        style={{
                            backgroundColor: '#F9F9F9',
                        }}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Box sx={{ flex: '1 1 auto' }} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                    {data.type === BozpDocumentNewsType.Document && <IconButton
                        size="small"
                        onClick={() => { if (signRef?.current) signRef?.current?.clear(); }}
                        disabled={signRef?.current?.isEmpty() === true || loading}
                    >
                        <Refresh />
                    </IconButton>}
                    <Button
                        startIcon={<Check />}

                        color="success"
                        variant="contained"
                        size="small"
                        onClick={handleSaveAsBase64}
                        disabled={loading || !isSigned}
                    >
                        {t('sign')}
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
};